import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../api";
import { ApiKeyCreate } from "../../generated/core-api";

const MCP_KEYS_QUERY_KEY = ["mcp-api-keys"];

export function useMcpKeys() {
  const queryClient = useQueryClient();

  const keysQuery = useQuery({
    queryKey: MCP_KEYS_QUERY_KEY,
    queryFn: () => api.listMcpApiKeys(),
  });

  const createKey = useMutation({
    mutationFn: (data: ApiKeyCreate) => api.createMcpApiKey(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MCP_KEYS_QUERY_KEY });
    },
  });

  const revokeKey = useMutation({
    mutationFn: (keyId: string) => api.revokeMcpApiKey(keyId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MCP_KEYS_QUERY_KEY });
    },
  });

  return {
    keys: keysQuery.data ?? [],
    isLoading: keysQuery.isLoading,
    error: keysQuery.error,
    createKey,
    revokeKey,
  };
}
